var $sticky;




$(document).ready(function($) {

  $sticky = $('.js-sticky')

  sticky();


  // Scroll event
  $(window).scroll(function() {
    sticky();
  });
});


function sticky() {

  if ($sticky.length >= 1) {
    $sticky.each(function() {
      var $parent = $(this).parent();
      var $anchor = $(this).next();
      var parentOffset = $parent.offset().top;
      var parentHeight = $parent.height();
      var offset = $anchor.offset().top - parentOffset;

      if (offset + $(this).height() > parentHeight) {
        $(this).addClass('is-at-bottom');
      } else {
        $(this).css('top', parentOffset);
        $(this).removeClass('is-at-bottom');
      }
    })
  }
}
